import { convertToKebabCase } from './convert-to-kebab-case'
import uuid from 'react-uuid'

export const composeId = (text: string) => {
  const prefix: string = convertToKebabCase(text)
  const uuidCode: string = uuid()

  return `${prefix}-${uuidCode}`
}
